import { render, staticRenderFns } from "./articlelisting.vue?vue&type=template&id=ec1b978c&"
import script from "./articlelisting.vue?vue&type=script&lang=js&"
export * from "./articlelisting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports